import React from "react";
import Button from "react-bootstrap/Button";
import { Form } from "semantic-ui-react";

import API from "../../../services/Api";
import useAuth from "../../login/AuthContext";

export const ClosingReminder: React.FunctionComponent = () => {
  const { getAuthToken } = useAuth();

  return (
    <Form>
      <Button onClick={async () => API.sendPush(null, "closingReminder", await getAuthToken())}>Send</Button>
    </Form>
  );
};
